import { createTheme, ThemeOptions } from '@mui/material/styles'
import { palette } from './palette'
import { typography } from './typography'
import { components } from './components'

// Create custom theme for financial/professional application
const themeOptions: ThemeOptions = {
  palette,
  typography,
  components,
  spacing: 8, // 8px base spacing
  shape: {
    borderRadius: 4, // Subtle rounded corners
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
}

export const theme = createTheme(themeOptions)

// Theme type augmentation for custom properties
declare module '@mui/material/styles' {
  interface Theme {
    custom: {
      sidebar: {
        width: number
        collapsedWidth: number
      }
      header: {
        height: number
      }
      colors: {
        success: string
        warning: string
        error: string
        info: string
        neutral: string
      }
    }
  }

  interface ThemeOptions {
    custom?: {
      sidebar?: {
        width?: number
        collapsedWidth?: number
      }
      header?: {
        height?: number
      }
      colors?: {
        success?: string
        warning?: string
        error?: string
        info?: string
        neutral?: string
      }
    }
  }
}

// Add custom properties to theme
export const customTheme = createTheme({
  ...themeOptions,
  custom: {
    sidebar: {
      width: 280,
      collapsedWidth: 64,
    },
    header: {
      height: 64,
    },
    colors: {
      success: '#2e7d32',
      warning: '#ed6c02',
      error: '#d32f2f',
      info: '#0288d1',
      neutral: '#6b7280',
    },
  },
})